import React, { useEffect, useState } from "react";
import { Phone, Calendar, ArrowUp } from "lucide-react";

export const FloatingActions = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Mobile call now button */}
      <a
        href="tel:4034043515"
        data-testid="floating-call"
        className="lg:hidden fixed bottom-5 left-5 z-40 inline-flex items-center gap-2 rounded-full bg-brand-black text-white px-5 py-3 text-sm font-semibold shadow-2xl shadow-black/25 active:scale-95 transition-all"
      >
        <Phone className="w-4 h-4" /> Call
      </a>

      {/* Book service pill */}
      <a
        href="#contact"
        data-testid="floating-book"
        className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-brand-red text-white px-5 py-3 text-sm font-semibold shadow-2xl shadow-red-500/30 hover:bg-[#CC0000] active:scale-95 transition-all"
      >
        <Calendar className="w-4 h-4" /> Book Service
      </a>

      {/* Back to top */}
      {show && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Back to top"
          data-testid="back-to-top"
          className="hidden lg:inline-flex fixed bottom-24 right-5 z-40 w-11 h-11 rounded-full bg-white border border-neutral-200 shadow-lg items-center justify-center hover:border-brand-red hover:text-brand-red transition-colors"
        >
          <ArrowUp className="w-4 h-4" />
        </button>
      )}
    </>
  );
};

export default FloatingActions;
